// LineChart.js
import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
} from "chart.js";

// Register Chart.js components
ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend
);

const LineChart = ({ rawData }) => {
  if (!rawData?.labels) {
    return <p>No data available</p>;
  }

  let datasets = [];

  // Case 1: If multiple stores are available
  if (rawData?.stores?.length) {
    datasets = rawData.stores.map((store) => ({
      label: store?.store_name,
      data: store?.data,
      borderColor: store?.color_code,
      backgroundColor: store?.color_code + "33",
      fill: false,
      tension: 0.3,
      pointRadius: 4,
      pointBackgroundColor: "#fff",
      pointBorderColor: store?.color_code,
    }));
  }

  // Case 2: If only a single array dataset (like low-stock-count) exists
  else {
    const singleKey = Object.keys(rawData).find(
      (key) => Array.isArray(rawData[key]) && key !== "labels"
    );

    if (singleKey) {
      datasets = [
        {
          label: singleKey.replace(/-/g, " ").toUpperCase(), // format key nicely
          data: rawData[singleKey],
          borderColor: "#3b82f6", // default blue
          backgroundColor: "#3b82f633",
          fill: false,
          tension: 0.3,
          pointRadius: 4,
          pointBackgroundColor: "#fff",
          pointBorderColor: "#3b82f6",
        },
      ];
    }
  }

  const chartData = {
    labels: rawData.labels,
    datasets: datasets,
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 12,
          font: {
            size: 12,
          },
        },
      },
      tooltip: {
        mode: "index",
        intersect: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0,
        },
      },
    },
  };

  return (
    <div style={{ height: "400px" }}>
      <Line data={chartData} options={chartOptions} />
    </div>
  );
};

export default LineChart;
